export function formatRenewalDate(
  value: string | null | undefined,
  locale: string,
): string {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleDateString(locale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  } catch {
    return '—';
  }
}
